<template>
  <b-button
    v-b-hover="handleHover"
    :variant="variant"
    size="sm"
    class="py-0"
    :disabled="isdisabled"
    @click="clickFunction"
  >
    <b-icon
      v-if="isHovered"
      :aria-label="label"
      :icon="iconhover"
    />
    <b-icon
      v-else
      :aria-label="label"
      :icon="iconnohover"
    />
  </b-button>
</template>

<script>
export default {
  name:'HoveredButton',
  props: {
    iconhover:{
      type:String,
      required:true
    },
    iconnohover:{
      type:String,
      required:true
    },
    label:{
      type:String,
      default:''
    },
    isdisabled: {
      type:Boolean,
      default:false
    },
    variant:{
      type:String,
      default:'primary'
    },
    clickFunction:{
      type:Function,
      required:true
    }
  },
  data(){
    return {
      isHovered:false
    }
  },
  methods:{
    handleHover(hovered) {//Handle the hover on the Add button
      this.isHovered = hovered
    },
  }
}
</script>

<style>

</style>